<template>
  <div class="yinsi">
    <div class="tag-template" style="display: flex;color: rgba(22, 23, 49, 1);font-size: 18px;line-height: 26px;justify-content: center;margin-bottom: 17px">
      <router-link to="fa0bc2" style="color: inherit;text-decoration: inherit;">
        <div class="tg-2" style="margin-right: 43px">
          服务协议
        </div>
      </router-link>
      <div class="tg-1 active-bottom">
        隐私政策
      </div>
    </div>
    <!-- <p class="title" style="text-align: center">隐私政策</p> -->
    <div class="block">
      <p class="two-title">我们非常重视您的隐私权。</p>
      <p class="common-p">广州心与潮信息科技有限公司（以下简称：心潮科技）
        致力于保护用户隐私权。本隐私权政策旨在向您说明，在使用我们的服务时，我们如何收集、存储、使用和管理这些信息。这些信息包括您向我们提供的个人信息或者我们通过我们网站或者移动应用终端收集到的相关信息。收集途径主要包括：移动设备上（如：苹果设备和安卓设备）提供的心潮科技应用程序产品(“我们的服务”)。
        使用我们的服务就意味着您同意本政策，并同意根据本政策中规定的方式对您的数据（包括您的个人信息）进行收集和处理。如果您不同意本政策及未来修订版本的任何条款，请不要使用服务。
      </p>
      <p class="common-p">
        如对本政策或任何隐私权相关问题有任何疑问及想更详细了解，请通过以下方式与我们取得联系，广州心与潮信息科技有限公司，成立于2015年4月22日，办公地址：广州市海珠区新滘中路88号海珠唯品同创汇，联系电话02087351934，邮件office@heartide.com。
      </p>
    </div>
    <div class="block">
      <p class="two-title">我们可能收集的信息</p>
      <p class="common-p">为了向您提供更好的服务，我们将在法律允许的范围内和当且仅当您使用某些功能或者服务时，收集您的相关数据和信息。</p>
    </div>
    <div class="block">
      <p class="two-title">您提供给我们的信息</p>
      <p class="common-p">在您使用我们的服务时，我们可能建议您注册一个帐号，以方便您充分利用我们的服务及其优势。当您注册帐号时，我们会收集您所提供的可识别您身份的信息，这些信息包括您的帐号名、移动电话号码等注册帐号所必须的信息。</p>
    </div>
    <div class="block">
      <p class="two-title">您使用服务时我们获取的信息</p>
      <p class="two-title">设备信息</p>
      <p class="common-p">当您在移动平台上使用任何心潮科技应用程序时，我们可能收集并记录某些信息，比如您的产品唯一身份标识（持续的／间断的）、硬件种类、介质访问控制（“MAC”）地址、国际移动电话设备识别码（“IMEI”）、您的操作系统（“OS”）版本、您设备的名称和您的位置（基于您的网络协议（“IP”）地址、SIM卡国家码、GPS）。这一信息有助于我们解决问题并了解总体用户使用倾向。</p>
      <p class="common-p">我们可能收集您的位置信息以向您提供正确的应用程序版本及更优质的服务。除本政策另有约定外，我们不会与任何第三方分享这一信息。如果您不再希望我们跟踪或使用这一信息，您可以在设备上关闭网络、GPS功能或者禁用我们获取您网络、GPS、设备信息权限。</p>
      <p class="common-p">此外，我们可能创建了唯一用户身份标识以跟踪您对我们服务的使用。此唯一用户身份标识与您的个人资料信息储存在一起，以便于了解您正在使用的心潮科技应用程序。</p>
    </div>
    <div class="block">
      <p class="two-title">使用日志</p>
      <p class="common-p">当您使用我们的服务，包括参与、生成、浏览与我们的服务相关的内容时，我们将会自动收集心潮科技应用内某些相关的日志信息，这些信息包括：(1)关于您的使用时间、使用频率和购买记录等细节；(2)设备统计信息、关键操作路径、错误日志、崩溃记录、语言和时区等。这些日志信息能够帮助我们更好的了解和改善我们的服务，并非用于识别任何特定的个人。</p>
    </div>
    <div class="block">
      <p class="two-title">广告</p>
      <p class="common-p">我们可能在服务中放映广告并且可能出于追踪广告目的收集并使用有关您的信息，例如您的设备标识符、MAC地址、IMEI、地理位置及IP地址。这些信息是为了用于创建内部用户编号以帮助我们更好地计数和追踪基于语言、地理位置和其他细节的广告。我们不会将这些信息出售给第三方。</p>
    </div>
    <div class="block">
      <p class="two-title">第三方收集的信息</p>
      <p class="common-p">我们提供的服务可能包括属于我们的服务供应商的第三方追踪工具。该第三方可能会在我们提供的服务中使用cookies、APIs（应用程序编程接口）及SDKs（软件程序开发包），由此代表我们收集并分析用户信息。第三方可能会访问诸如您的设备标识符、MAC（媒体访问控制）地址、IMEI（移动设备国际身份码）、区域（使用给定语言的特定地点）、地理位置信息及IP地址等信息，旨在实现在其各自隐私权政策下提供服务。我们的隐私权政策不会覆盖到第三方追踪工具的使用。我们没有权限访问或控制这些第三方。如果您想知道更多相应第三方信息，请发送电子邮件至office@heartide.com。</p>
    </div>

    <p style="font-weight:700">集成SDK服务及权限使用说明</p>
    <p>（1）友盟+SDK<br/>
      我们的产品集成友盟+SDK，需要允许程序收集您的设备Mac地址、唯一设备识别码（IMEI/android ID/IDFA/OPENUDID/GUID、SIM 卡 IMSI 信息）以提供统计分析服务，并通过地理位置校准报表数据准确性，提供基础反作弊服务。</p>
    <p>（2）创蓝闪验SDK<br/>
      我的产品集成创蓝闪验SDK，需要允许程序访问您的网络状态，获取token（通过authenticationRespond获取），服务端携带输入的手机号码和token去运营商网关进行校验（服务端调用mobile-validate接口），以校验您的本机号码并提供一键登录账号的服务。</p>
    <p>（3）FileDownloader SDK<br/>
      我们的产品集成FileDownloader SDK，需要允许程序读写您的外部存储,如SD卡上写文件，以提供音频文件下载保存的服务。</p>
    <p>（4）七牛SDK<br/>
      我们的产品集成七牛SDK，需要允许程序读取您的设备外部存储空间(内置SDcard和外置SDCard) 的文件，以提供音频文件下载完整性校验、以及用户账号头像上传的服务。
    </p>
    <p>（5）腾讯Bugly SDK<br/>
      我们的产品集成七牛SDK，需要允许程序读取您的网络状态以提供崩溃日志上报、热修复、版本更新推送的服务。</p>
    <p>（6）takephoto_library SDK<br/>
      我们的产品集成takephoto_library，需要允许程序访问您的相机权限，以提供帐号头像图片选择器和裁剪的功能。</p>
    <p>（7）微信支付SDK<br/>
      我们的产品集成微信支付SDK，需要允许程序访问您的网络状态，以保障帐号安全并提供支付服务。</p>
    <p>（8）支付宝SDK<br/>
      我们的产品集成支付宝SDK，需要允许程序访问您的网络状态，以保障帐号安全并提供支付服务。</p>
    <p>（9）腾讯广点通广告SDK<br/>
      我们的产品集成腾讯广点通广告SDK，需要允许程序访问您的网络状态来获取粗略位置，以提供广告展示的业务。</p>
    <p>（10）头条穿山甲广告SDK<br/>
      我们的产品集成头条穿山甲广告SDK，需要允许程序访问您的网络状态来获取粗略位置，以提供广告展示的业务。</p>
    <p>（11）友盟分享SDK<br/>
      我们的产品集成友盟分享SDK，需要允许程序访问您的网络状态，以提供内容分享（包含QQ、微信、微博、Facebook）的服务。</p>
    <p>（12）Google登录SDK<br/>
      我们的产品集成Google登录SDK，程序仅用于提供登录第三方帐号服务，不需要任何访问权限。</p>
    <p>（13）魅族推送SDK<br/>
      我们的产品集成魅族推送SDK，需要允许程序访问您的网络状态、读取设备外部存储空间、访问电话状态以提供消息通知的服务。</p>
    <p>（14）华为推送SDK<br/>
      我们的产品集成华为推送SDK，需要允许程序访问您的网络状态、读取设备外部存储空间、访问电话状态以提供消息通知的服务。</p>
    <p>（15）小米推送SDK<br/>
      我们的产品集成小米推送SDK，需要允许程序访问您的网络状态、读取设备外部存储空间、访问电话状态以提供消息通知的服务。</p>
    <p>（16）OPPO推送SDK<br/>
      我们的产品集成OPPO推送SDK，需要允许程序访问您的网络状态、读取设备外部存储空间、访问电话状态以提供消息通知的服务。</p>
    <p>（17）vivo推送SDK<br/>
      我们的产品集成vivo推送SDK，需要允许程序访问您的网络状态、读取设备外部存储空间、访问电话状态以提供消息通知的服务。</p>
    <p>（18）Zxing二维码扫描SDK<br/>
      我们的产品集成Zxing二维码扫描SDK，程序仅用于内部人员调试，不对大众用户开放。</p>
    <p>（19）Glide SDK<br/>
      我们的产品集成Glide SDK，需要允许程序访问您的网络状态，以提供加载图片内容的服务。</p>
    <p>（20）OkHttp SDK<br/>
      我们的产品集成OkHttp SDK，需要允许程序访问您的网络状态，以提供网络请求的服务。</p>
    <p>（21）RxJava SDK<br/>
      我们的产品集成RxJava SDK，程序仅用于提供响应式编程框架基础服务，不需要任何访问权限。</p>
    <p>
      （22）应用商店联运SDK<br/>
      我们的产品在部分商店渠道的版本集成了联运SDK（包含华为联运SDK、OPPO联运SDK、vivo联运SDK、小米联运SDK、魅族联运SDK），需要允许程序访问您的网络状态，以提供应用内支付购买的服务。
    </p>

    <div class="block">
      <p class="two-title">我们如何使用信息</p>
      <p class="common-p">我们收集用户信息是以提升服务质量与用户体验为目的，为了实现这一目的，我们可能将您的信息用于：</p>
    </div>
    <div class="block">
      <p class="two-title">(一) 创建帐号；</p>
      <p class="two-title">(二) 运营及改善我们的服务；</p>
      <p class="two-title">(三) 了解您与您的喜好，以提升您使用我们服务的体验与乐趣；</p>
      <p class="two-title">(四) 回复您的评论与问题，并提供客户服务；</p>
      <p class="two-title">(五) 提供及交付您要求的产品与服务；</p>
      <p class="two-title">(六) 发送与您相关的信息，包括确认、技术通告、更新、安全警告、支持及行政信息；</p>
      <p class="two-title">(七) 使您能与其他用户交流；</p>
      <p class="two-title">(八) 将其与我们从第三方获得的其他信息相联系或结合，以更好地了解您的喜好并为您提供更优质的服务;</p>
      <p class="two-title">(九) 为上述目的，在其他国家处理您的信息。</p>
    </div>
    <div class="block">
      <p class="common-p">除非下列情形发生时，我们无权披露您的全部或部分信息：</p>
      <p class="two-title">(一) 为保护他人的人身或财产安全；</p>
      <p class="two-title">(二) 为防止或解决网络欺诈；</p>
      <p class="two-title">(三) 维护心潮科技的合法权利及权益;</p>
      <p class="two-title">(四) 实现“我们可能收集的信息”部分所述目的，前提条件为该等披露接收方应同等接受本政策约束并可以提供信息充分保护；</p>
      <p class="two-title">(五) 根据法律、法规的规定，或遵从政府部门、司法机关的要求；通常前述要求都是为了保护网络安全和保护我们、我们的用户和第三方的权利、财产和安全。</p>
    </div>
    <div class="block">
      <p class="two-title">信息安全性</p>
      <p class="common-p">我们使用合理措施，以防信息的丢失、不当使用、未经授权阅览或披露。例如，在某些服务中，我们将利用加密技术来保护您提供的个人信息。但请您理解（在互联网行业）即便竭尽所能加强安全措施，也不可能始终保证信息百分之百的安全。您需要了解，您接入我们的服务所用的系统和通讯网络，有可能因我们可控范围外的因素而出现问题。</p>
    </div>
    <div class="block">
      <p class="two-title">信息访问与控制</p>
      <p class="common-p">我们将采取一切合理适当的技术手段，保证您可以访问、更新和更正自己的注册信息或使用我们的服务时提供的其他个人信息。在访问、更新、更正和删除前述信息时，我们可能会要求您进行身份验证，以保障帐号安全。</p>
    </div>
    <div class="block">
      <p class="two-title">数据保留</p>
      <p class="common-p">受限于法律法规要求，我们将按照“我们如何使用信息”章节或者为您提供服务的时间范围内保留您的信息。如果您希望删除您的帐号或者要求我们不得再使用您的信息为您提供服务，请发送电子邮件至office@heartide.com。</p>
    </div>
    <div class="block">
      <p class="two-title">儿童信息</p>
      <p class="common-p">我们不会有意向13周岁以下的人群收集或请求个人信息。如果您低于13周岁，请不要向我们发送您的个人信息，包括您的名字、地址、电话号码或者邮箱地址。如果您认为我们可能有13周岁以下儿童任何信息时，请发送电子邮件至office@heartide.com。</p>
    </div>
    <div class="block">
      <p class="two-title"></p>
      <p class="common-p"></p>
    </div>
    <div class="block">
      <p class="common-p" style="text-align: right">
        广州心与潮信息科技有限公司<br/>
        2020年7月15日
      </p>
    </div>

    <div style="text-align: left">附录：</div>

    <div style="margin-bottom: 20px;font-weight: bold">SDK集成以及所需权限列表</div>

    <div class="grid-table">
      <div>SDK集成列表</div>
      <div>SDK用途说明</div>
      <div>所需权限列表</div>

      <div>创蓝闪验登录</div>
      <div>可为用户提供本机号码一键登录的服务</div>
      <div style="padding: 0px" class="inner-code-parent">
        <div class="inner-code" v-for="(li, index) in code1" :key="index">{{li}}</div>
      </div>

      <div>友盟统计</div>
      <div>
        统计用户活跃等运营数据所需
      </div>
      <div class="inner-code-parent">
        <div class="inner-code"  v-for="(li, index) in code2" :key="index">{{li}}</div>
      </div>

      <div style="word-break: break-all;">FileDownloader</div>
      <div>
        文件下载组件
      </div>
      <div class="inner-code-parent">
        <div  class="inner-code" style="word-break: break-all;'" v-for="(li, index) in code3" :key="index">{{li}}</div>
      </div>

      <div>七牛SDK</div>
      <div>
        文件下载完整性校验、用户账号头像上传
      </div>
      <div  class="inner-code-parent">
        <div  class="inner-code" style="word-break: break-all;'" v-for="(li, index) in code4" :key="index">{{li}}</div>
      </div>

      <div>腾讯Bugly</div>
      <div>
        崩溃日志上报、热修复、版本更新推送
      </div>
      <div  class="inner-code-parent">
        <div class="inner-code"  v-for="(li, index) in code5" :key="index">{{li}}</div>
      </div>

      <div style="word-break: break-all;">takephoto_library</div>
      <div>
        为用户提供账号头像图片选择器和裁剪器
      </div>
      <div  class="inner-code-parent">
        <div class="inner-code"  v-for="(li, index) in code6" :key="index">{{li}}</div>
      </div>

      <div>
        微信支付
      </div>
      <div>
        为用户提供支付服务
      </div>
      <div  class="inner-code-parent">
        <div  class="inner-code" style="word-break: break-all;'" v-for="(li, index) in code7" :key="index">{{li}}</div>
      </div>

      <div>
        支付宝
      </div>
      <div>
        为用户提供支付服务
      </div>
      <div class="inner-code-parent">
        <div  class="inner-code" style="word-break: break-all;'" v-for="(li, index) in code8" :key="index">{{li}}</div>
      </div>
    </div>
    <div style="width: 100px;height: 40px"></div>
  </div>
</template>

<script>
export default {
  name: 'yinsi',
  data () {
    return {
      code1: ['INTERNET',
        'WRITE_SETTINGS',
        'ACCESS_WIFI_STATE',
        'ACCESS_NETWORK_STATE',
        'CHANGE_NETWORK_STATE',
        'CHANGE_WIFI_STATE',
        'GET_TASKS',
        'READ_PHONE_STATE'],
      code2: [
        'ACCESS_NETWORK_STATE',
        'ACCESS_WIFI_STATE',
        'READ_PHONE_STATE',
        'INTERNET'
      ],
      code3: [
        'INTERNET',
        'WRITE_EXTERNAL_STORAGE',
        'READ_EXTERNAL_STORAGE'
      ],
      code4: [
        'INTERNET',
        'WRITE_EXTERNAL_STORAGE',
        'READ_EXTERNAL_STORAGE'
      ],
      code5: [
        'INTERNET',
        'ACCESS_WIFI_STATE',
        'ACCESS_NETWORK_STATE',
        'WRITE_EXTERNAL_STORAGE'
      ],
      code6: [
        'WRITE_EXTERNAL_STORAGE',
        'CAMERA'
      ],
      code7: [
        'INTERNET',
        'ACCESS_WIFI_STATE',
        'READ_PHONE_STATE',
        'ACCESS_NETWORK_STATE'
      ],
      code8: [
        'INTERNET',
        'ACCESS_WIFI_STATE',
        'ACCESS_NETWORK_STATE'
      ]
    }
  },
  mounted () {
    document.title = '隐私政策'
  }
}
</script>

<style lang="scss" scoped>
.yinsi {
  p {
    text-align: left;
    margin-bottom: 10px;
  }
  font-size: 14px;
  box-sizing: border-box;
  margin-top: 20px;
  padding-left: 21px;
  padding-right: 21px;
  .title {
    font-size: 16px;
    font-weight: 900;
    margin-bottom: 28px;
  }
  .block {
    margin-bottom: 28px;
  }
  .two-title {
    font-weight: 700;
    text-align: left;
    margin-bottom: 14px;
  }
  .common-p {
    text-align: left;
    margin-bottom: 7px;
  }

  .grid-table {
    align-items: center;
    font-size: 12px;
    display: grid;
    width: 100%;
    overflow: hidden;
    grid: repeat(3, min-content) / repeat(3, minmax(100px, 1fr));
    text-align: left;
    grid-gap: 0px 0px;
    >div {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      border: 1px solid rgba(0, 0, 0, 1);
      padding: 5px;
      box-sizing: border-box;
      height: 100%;
      width: 100%;
      margin-left: 0px;
      margin-top: 0px;
      >div {
        width: 100%;
        text-align: left;
        border: 1px solid #fff;
        height: 100%;
      }
    }
  }
}
  .inner-code-parent {
    padding: 0px !important;
    .inner-code {
      box-sizing:border-box;
      padding: 4px;word-break: break-all;border-bottom: 1px solid #000!important;
      font-size: 10px;
    }
    .inner-code:last-of-type {
      border-bottom: unset!important;
    }
  }
</style>
<style>
  .active-bottom {
    position: relative;
  }
  .active-bottom::after {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: -3px;
    content: '';
    width: 60px;
    height: 3px;
    border-radius: 1.5px;
    background: linear-gradient(rgba(173, 114, 252, 1), rgba(109, 121, 254, 1));
  }
</style>
